import {h, Fragment} from "preact"
import { useFacets, useSelectedFiltersCount, useProductFilters, useAppStateSelector, pick, useCurrencyFormatting } from "@nosto/preact"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import Icon from "./elements/Icon"
import { sortSizeData, isMobile, transformRangeFacetData, closeSidebar } from "../helpers"
import { FilterRemoveButton } from "./SelectedFilters"


export const toggleButtonId = "toggle-mobile-sidebar"

function ToggleSidebarButton({ className }) {
    return (
        <label
            className={`ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ${className}`}
            for={toggleButtonId}
        >
            <Icon name="close" />
        </label>
    )
}

export default function SideBar({isChecked,setIsChecked}) {
    const { loading, facets } = useFacets();
    const selectedFiltersCount = useSelectedFiltersCount();
    const { filters, removeAll } = useProductFilters();
    const { query, response, pageType } = useAppStateSelector(state =>
        pick(state, "query", "response", "pageType")
    )
    const { format } = useCurrencyFormatting();

    const handleChange = (event) => {
        setIsChecked(event.target.checked);
    };
    const docCount = response.products?.total ?? 0;
    // pageType === "category" ? `${docCount} results` : `'${query.query}' - 
    const totalSummary = `${docCount} results`

    return facets?.length > 0 ? (
        <>
            <input type="checkbox" id={toggleButtonId} class="ns-facet-sidebar-toggle ns-d-none" onChange={handleChange} />
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for={toggleButtonId}
            />
            <div
            // ns-d-md-block ns-h-100
                class="ns-sidebar-wrapper ns-d-none ns-col-3 ns-col-l-2"
                style={loading ? "opacity: 0.3;" : ""}
            >
                {/* ns-h-100 ns-background-white */}
                <div class="ns-sidebar-content ns-relative ns-mr-0 ns-mr-md-auto">
                    <div class="ns-sidebar-header ns-d-none ns-align-items-baseline ns-relative">
                        <span class="ns-font-bold ns-font-5 ns-color-black">Filter</span>
                        {selectedFiltersCount > 0 && (
                            <span className="ns-total-count ns-d-inline-block ns-text-align-center">
                                {selectedFiltersCount}
                            </span>
                        )}
                        <ToggleSidebarButton />
                    </div>
                    <div class="ns-sidebar-menu">
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0 ns-d-flex">
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        if(facet?.field === 'skus.customFields.size'){
                                            sortSizeData(facet.data)
                                        }
                                        return <Facet key={facet.id} facet={facet} />
                                    case "stats":
                                        return <RangeFacet key={facet.id} facet={facet} />
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>
                </div>
                {isMobile && <div class="filter-drawer__footer animation--filter-drawer-item ns-sidebar-footer" style="--delay-offset-multiplier: 4;">
                    <div class="filter-drawer__footer-active-filters">
                        <div class="active-filters">
                        {filters.length > 0 && filters.map(filter => {
                            const isPriceFilter = filter.field === "price";
                            return (
                                <div
                                    key={`${filter.name}: ${filter.value}`}
                                    class="ns-selected-filter ns-d-flex ns-align-items-center fs-body-75"
                                >
                                    <span class="ns-color-black">
                                        {isPriceFilter ? transformRangeFacetData(filter.value, format) : filter.value}
                                    </span>
                                    <FilterRemoveButton filter={filter} />
                                </div>
                            )
                        })}
                        </div>
                    </div>
                    <div class="filter-drawer__footer-buttons">
                        {/* <button type="button" class={`filter-drawer__button-clear btn btn--text-link fs-body-75 ${filters?.length > 0 ? "ns-clear-all-visible" : ""}`} onClick={(e) => {
                            e.preventDefault();
                            removeAll();
                        }}>
                            Clear all
                        </button> */}
                        <span
                            class="ns-anchor ns-text-align-right fs-body-75 ns-clear-all-filters-btn"
                            onClick={() => {
                                removeAll()
                            }}
                        >
                            Clear All
                        </span>
                        <p class="filter-drawer__results-count fs-body-50 fc">{totalSummary}</p>
                        <button type="button" class="filter-drawer__button-apply btn btn--primary" onClick={(e)=>{
                            e.preventDefault();
                            closeSidebar();
                        }}>
                            Done
                        </button>
                    </div>
                </div>}
            </div>
        </>
    ) : (
        ""
    )
}
